import PropTypes from 'prop-types';

const TextInput = ({ id, title, setValue, values, isRequired, disabled }) => (
  <div className="input-wrapper">
    <label htmlFor={id}>
      {title} {isRequired && <span className="color-red">*</span>}
    </label>
    <input
      id={id}
      className="form-control"
      type="text"
      autoComplete="off"
      disabled={disabled}
      value={values[id] || ''}
      onChange={(e) => {
        setValue({ [id]: e.target.value });
      }}
    />
  </div>
);

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  setValue: PropTypes.func,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  values: PropTypes.shape(),
};

export default TextInput;
